<style>
@import '../../assets/css/transaction.css';
</style>

<template>
    <div class="main-panel">
        <div class="main-content">
            <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                <form @submit.prevent="initialize" :submit="initialize">
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_username')}}</template>
                        <el-input v-model="ajaxSearch.login" clearable></el-input>
                    </b-form-group>
                </form>
            </b-card>
            <b-card :header="$t($route.name)">
                <b-button variant="primary" class="mb-3 float-right" v-b-modal.importTopupGca v-if="permissionList.includes(permission.import)"><font-awesome-icon icon="plus"/> {{$t('admin.table_topup_gca_import')}}</b-button>
                <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                        <template slot="header">
                            <p>{{title.label}}</p>
                            <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                        </template>
                    </el-table-column>
                </el-table>
                <b-row class="mt-3">
                    <b-col sm="12" md="3" class="pr-0">
                        <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                    </b-col>
                    <b-col sm="12" md="9" class="pl-0">
                        <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                    </b-col>
                </b-row>
            </b-card>

            <b-modal id="importTopupGca" :title="$t('admin.table_topup_gca_import')" @ok="importTopupGca" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                <form id="importTopupGcaForm" @submit.prevent="importTopupGca">
                    <b-form-group label-cols="4" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_import_file')}}</template>
                        <b-form-file name="uploadFile"></b-form-file>
                    </b-form-group>
                </form>
            </b-modal>
        </div>
    </div>
</template>

<script>
import {topupGcaAjaxTable,topupGcaImport} from '@/system/model/transaction'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            ajaxTable:[],
            ajaxTool:[],
            ajaxToolList:[],
            ajaxSearch:{limit:'',pagination:'',id:'',created_at:'',login:'',remark:''},
            ajaxRow:'',
            ajaxEdit:[],
            ajaxExportStart:'',
            ajaxExportEnd:'',
            statusList:[],
            showEdit: false,
            pageLimit:10,
            ajaxInfo:'',
            showUrl:false,
            ajaxUrl:'',
            ajaxCode:'',
            permission:{
                import:'56CD13',
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width:'80'
            },{
                prop: "created_at",
                label: this.$t('admin.table_date'),
                width:'200'
            },{
                prop: "login",
                label: this.$t('admin.table_username'),
                width:'200'
            },{
                prop: "remark",
                label: this.$t('admin.table_remark'),
                width:'200'
            }],        
        }
    },methods:{
        initialize(){
            var self = this;
            var result = topupGcaAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.created_at,this.ajaxSearch.login,this.ajaxSearch.remark);
            this.preloader(true);
            result.then(function(value){
                if(value.valid){
                    self.preloader(false);
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.preloader(false);
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getToolList(){
            var self = this;
            var result = this.$general.getToolList();
            result.then(function(value){
                self.ajaxToolList = value.data;
            });
        },importTopupGca(){
            if(this.permissionList.includes(this.permission.import)){
                var self = this;
                var form = document.getElementById('importTopupGcaForm');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                var result = topupGcaImport(formData);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();  
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();  
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id;
            this.ajaxCode = row.code;
            this.showEdit = false;
            if(row.status != 3 && row.status != 4 && row.status != 5){
                this.showEdit = true;
            }
            if(row.status == 3 || row.status == 4 || row.status == 5){
                this.showUrl = true;
                this.ajaxUrl = row.url
            }
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
        this.getToolList();
    }
}
</script>
